module.exports = __webpack_public_path__ + "src/assets/img/note.727fd514.png";